import { render, staticRenderFns } from "./EventDetailHover.vue?vue&type=template&id=58789a70"
import script from "./EventDetailHover.ts?vue&type=script&lang=ts&external"
export * from "./EventDetailHover.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports